import React from "react";
import InputForm from "../../../../Misc/InputForm";
import Context from "../../../../../Context";

export default class UserDeatilProfile extends React.Component {
  static contextType = Context;
  save = async (data) => {
    data.id = this.props.user["id"];
    this.props.onPending(true);
    let result = await this.context.api.q("/admin/user/set", data);
    if (result !== false) {
      this.context.toast("Профиль пользователя сохранен", "success");
      this.props.onFinish();
    } else {
      this.context.toast("Не удалось сохранить профиль прользователя", "error");
      this.props.onPending(false);
    }
  };
  render() {
    let data = this.props.user || {};
    let key = data["id"];
    return (
      <>
        <InputForm
          fields={{
            username: {
              title: "Логин",
              type: "text",
              validate: true,
              error: false,
              default: "",
              col: "6",
            },
            email: {
              title: "Email",
              type: "text",
              validate: false,
              error: false,
              default: "",
              col: "6",
            },
            name: {
              title: "Имя",
              type: "text",
              validate: true,
              error: false,
              default: "",
              col: "6",
            },
            phone: {
              title: "Телефон",
              type: "text",
              validate: false,
              error: false,
              default: "",
              col: "6",
            },

            description: {
              title: "Описание",
              type: "text",
              validate: false,
              error: false,
              default: "",
            },
            password: {
              title: "Установить новый пароль",
              type: "text",
              validate: false,
              error: false,
              default: "",
            },
            passwordchange: {
              title: "Необходимо поменять пароль",
              type: "check",
              validate: false,
              error: false,
              default: false,
            },
            passwordnotchange: {
              title: "Запрет смены пароля",
              type: "check",
              validate: false,
              error: false,
              default: false,
            },
          }}
          data={data}
          key={key}
          onSubmit={this.save}
        />
      </>
    );
  }
}
